import global from '@/core/global/global.js'
var url = '';
if (global.global.ispc) {
  url = 'Redackpc'
} else {
  url = 'mobileyd';
}
export default [
  {
    path: '/',
    name: '',
    component: resolve => require([`@/views/${url}/cardHome`], resolve),
    // redirect: '/card',
    children: [
      {
        path: '/card',
        name: 'card',
        // meta: {
        //   title: '采编名片',
        // },
        component: resolve => require([`@/views/${url}/cardHome`], resolve),
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '快速注册登录',
    },
    component: resolve => require([`@/views/${url}/login`], resolve),
  },
  {
    path: '/reactive',
    name: 'reactive',
    meta: {
      title: '注册',
    },
    component: resolve => require([`@/views/${url}/login/reactive`], resolve),
  },
  {
    path: '/passList',
    name: 'passList',
    meta: {
      title: '修改密码',
    },
    component: resolve => require([`@/views/${url}/login/passList`], resolve),
  },

  {
    path: '/test',
    name: 'test',
    // meta: {
    //   title: '采编名片',
    // },
    component: resolve => require([`@/views/${url}/test`], resolve),
  },
  {
    path: '/contributionKnow',
    name: 'contributionKnow',
    // meta: {
    //   title: '投稿须知',
    // },
    component: resolve => require([`@/views/${url}/contributionKnow`], resolve),
  },
  {
    path: '/columnSet',
    name: 'columnSet',
    // meta: {
    //   title: '栏目设置',
    // },
    component: resolve => require([`@/views/${url}/columnSet`], resolve),
  },
  {
    path: '/progressQuery',
    name: 'progressQuery',
    // meta: {
    //   title: '进度查询',
    // },
    component: resolve => require([`@/views/${url}/progressQuery`], resolve),
  },
  {
    path: '/progressDetail',
    name: 'progressDetail',
    // meta: {
    //   title: '进度查询详情',
    // },
    component: resolve => require([`@/views/${url}/progressQuery/detail`], resolve),
  },
  {
    path: '/getArticleNotice',
    name: 'getArticleNotice',
    // meta: {
    //   title: '征文&通知',
    // },
    component: resolve => require([`@/views/${url}/getArticleNotice`], resolve),
  },
  {
    path: '/noticeDetails',
    name: 'noticeDetails',
    // meta: {
    //   title: '通知详情',
    // },
    component: resolve => require([`@/views/${url}/noticeDetails`], resolve),
  },
  {
    path: '/paperDetails',
    name: 'paperDetails',
    // meta: {
    //   title: '论文详情',
    // },
    component: resolve => require([`@/views/${url}/paperDetails`], resolve),
  },
  {
    path: '/myCollection',
    name: 'myCollection',
    // meta: {
    //   title: '我的收藏',
    // },
    component: resolve => require([`@/views/${url}/myCollection`], resolve),
  },
  {
    path: '/cardCollection',
    name: 'cardCollection',
    // meta: {
    //   title: '名片收藏',
    // },
    component: resolve => require([`@/views/${url}/cardCollection`], resolve),
  },
  {
    path: '/myCard',
    name: 'myCard',
    // meta: {
    //   title: '采编',
    // },
    component: resolve => require([`@/views/${url}/myCard`], resolve),
  },
  {
    path: '/search',
    name: 'search',
    // meta: {
    //   title: '采编名片',
    // },
    component: resolve => require([`@/views/${url}/search`], resolve),
  },
  {
    path: '/myComplaint',
    name: 'myComplaint',
    // meta: {
    //   title: '我的投诉',
    // },
    component: resolve => require([`@/views/${url}/myComplaint`], resolve),
  },
  {
    path: '/complaint',
    name: 'complaint',
    // meta: {
    //   title: '投诉',
    // },
    component: resolve => require([`@/views/${url}/complaint`], resolve),
  },
  {
    path: '/modifyCard',
    name: 'modifyCard',
    // meta: {
    //   title: '修改名片',
    // },
    component: resolve => require([`@/views/${url}/modifyCard`], resolve),
  },
  {
    path: '/myData',
    name: 'myData',
    // meta: {
    //   title: '个人资料',
    // },
    component: resolve => require([`@/views/${url}/myData`], resolve),
  },
  {
    path: '/consult',
    name: 'consult',
    // meta: {
    //   title: '咨询',
    // },
    component: resolve => require([`@/views/${url}/consult`], resolve),
  },
  {
    path: '/browseRecord',
    name: 'browseRecord',
    // meta: {
    //   title: '浏览记录',
    // },
    component: resolve => require([`@/views/${url}/browseRecord`], resolve),
  },
  {
    path: '/nameSearch',
    name: 'nameSearch',
    component: resolve => require([`@/views/${url}/nameSearch`], resolve),
  },
  {
    path: '/searchResult',
    name: 'searchResult',
    component: resolve => require([`@/views/${url}/searchResult`], resolve),
  },
  {
    path: '/progressList',
    name: 'progressList',
    component: resolve => require([`@/views/${url}/progressList`], resolve),
  },
  {
    path: '/progressStatus',
    name: 'progressStatus',
    component: resolve => require([`@/views/${url}/progressStatus`], resolve),
  },
]
